import React from 'react';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import AuthFlowManager from "./AuthFlowManager";

interface FormLoginProps {
    prefillEmail?: string;
    onEmailChange?: (email: string) => void;
}

const FormLogin: React.FC<FormLoginProps> = React.memo(({ prefillEmail, onEmailChange }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                width: '100%',
                flex: 1,
                minHeight: 0 // Allows flex children to shrink below content size
            }}
        >
            {/* Header - Pinned at top */}
            <Box
                sx={{
                    flexShrink: 0,
                    pb: 2
                }}
            >
                <Typography variant="h4" component="h1" gutterBottom align="center">
                    Welcome Back
                </Typography>
            </Box>

            {/* Form content - Scrollable area with spacing from header */}
            <Box
                sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: 0,
                    overflowY: 'auto',
                    pt: 2,
                    pb: 4
                }}
            >
                <AuthFlowManager
                    flowType="login"
                    prefillEmail={prefillEmail}
                    onEmailChange={onEmailChange}
                    onStepTransition={(step, error, data) => {
                        // Handle step transitions for login flow
                    }}
                    initialStepConfig={{
                        login: 'enabled',
                        verifyEmail: 'hidden',
                        setupMFA: 'hidden',
                        verifyMFA: 'hidden'
                    }}
                />
            </Box>

        </Box>
    );
});

FormLogin.displayName = 'FormLogin';

export default FormLogin;
